import { render, staticRenderFns } from "./WorksheetTypeDefinitionEdit.vue?vue&type=template&id=8f120674"
import script from "./WorksheetTypeDefinitionEdit.vue?vue&type=script&lang=js"
export * from "./WorksheetTypeDefinitionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports